var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud-computing 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.6618 11.763C25.1828 5.87131 19.2078 2.29407 13.3161 3.77304C8.71181 4.92885 5.36861 8.90823 5.02415 13.6428C1.75494 14.1819 -0.458254 17.2691 0.0808743 20.5383C0.560134 23.4447 3.07848 25.5732 6.02404 25.5615H11.0235V23.5617H6.02404C3.81515 23.5617 2.02447 21.771 2.02447 19.5621C2.02447 17.3532 3.81515 15.5626 6.02404 15.5626C6.57629 15.5626 7.02393 15.1149 7.02393 14.5627C7.01893 9.59265 11.0439 5.55959 16.0139 5.55466C20.3162 5.55034 24.0198 8.59189 24.852 12.8129C24.9342 13.2343 25.2762 13.5563 25.7019 13.6128C28.4355 14.002 30.3358 16.5336 29.9466 19.2671C29.5971 21.7217 27.5013 23.5493 25.022 23.5617H21.0224V25.5615H25.022C28.8875 25.5498 32.0117 22.4066 31.9999 18.541C31.9902 15.3233 29.7877 12.5266 26.6618 11.763Z",
    fill: "#2D3958"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.313 15.8533L11.3135 19.8528L12.7233 21.2627L15.0231 18.9729V28.5619H17.0229V18.9729L19.3126 21.2627L20.7224 19.8528L16.7229 15.8533C16.3329 15.4656 15.7031 15.4656 15.313 15.8533Z",
    fill: "#2D3958"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.4744f1a1578c789b5768b2b3a830c3e0.svg";
export { ForwardRef as ReactComponent };